exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message {\n    margin: 1em !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/loading/loading.component.css
// module id = 856
// module chunks = 0